import { render, staticRenderFns } from "./hexiao.vue?vue&type=template&id=70d6b992&"
import script from "./hexiao.vue?vue&type=script&lang=js&"
export * from "./hexiao.vue?vue&type=script&lang=js&"
import style0 from "./hexiao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports